import { graphql } from "../../shared/schema/gql";

export const GET_SERVICE_PLANS_QUERY = graphql(`
  query GetServicePlans(
    $order: [PatientServicePlan__Order]!
    $limit: Int!
    $offset: Int!
    $statuses: [PatientServicePlanStatus!]
    $officeIds: [OfficeId!]
    $search: String
  ) {
    patientServicePlans(
      order: $order
      limit: $limit
      offset: $offset
      statuses: $statuses
      officeIds: $officeIds
      search: $search
    ) {
      totalCount
      nodes {
        id
        status
        startDate
        endDate
        program
        service
        caseManagerName
        tasksCount
        unmappedTasksCount
        hasPdf
        createdAt
        patient {
          id
          firstName
          middleName
          lastName
          status
          displayId
          gender
          currentOffice {
            id
            name
          }
        }
        signatureClaims {
          nodes {
            id
            role
            recipientEmail
            status
            expiresAt
          }
        }
      }
    }
  }
`);

export const GET_CO_SERVICE_PLAN_IMPORTS_QUERY = graphql(`
  query GetCoServicePlanImports(
    $order: [CoServicePlanSubmission__Order]!
    $limit: Int!
    $offset: Int!
    $statuses: [CoServicePlanImportStatus!]
    $officeIds: [OfficeId!]
    $receivedFrom: LocalDate
    $receivedTo: LocalDate
    $search: String
  ) {
    coServicePlanSubmissions(
      order: $order
      limit: $limit
      offset: $offset
      statuses: $statuses
      officeIds: $officeIds
      receivedFrom: $receivedFrom
      receivedTo: $receivedTo
      search: $search
    ) {
      totalCount
      nodes {
        id
        submissionId
        planKind
        planLogId
        planVersion
        status
        receivedAt
        finalizedAt
        startDate
        endDate
        planOfCareId
        dutiesCount
        caregiversCount
        templateShiftsCount
        visitsCount
        warningsCount
        unstaffedCount
        modelAttempts
        engine
        jobRetryCount
        jobMaxRetries
        jobMessage
        actualDaysCount
        actualWeeklyMinutes
        currentDaysCount
        currentWeeklyMinutes
        proposedDaysCount
        proposedWeeklyMinutes
        patient {
          id
          firstName
          middleName
          lastName
          displayId
          status
          gender
          currentOffice {
            id
            name
          }
        }
      }
    }
  }
`);
